import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import {
  callApi,
  fnGetDataSet,
  fnSave,
  fnGetTableById,
} from "@shared/api/restApi"; // BackEnd API
import {
  getInitForm,
  getInitFormData,
  getTablebySql,
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/GridV2/SnGrid";
import { menuInfo } from "@shared/type/CommonType"; // 공통 Interface
import SnButton from "@shared/components/SnButton";
import SnTab from "@shared/components/SnTab";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import {
  extractAddInfoFlags,
  hydrateRowsWithAddInfo,
} from "@shared/utils/AddInfoUtils";
interface Props {
  Menuprops: menuInfo;
}
interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_PRD_WMO_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global(); // Login user 정보
  //#endregion
  const focusKeyRef = useRef<{
    no_wo?: string;
  } | null>(null);
  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [selectedTabPage, setTapPage] = useState<string>("1");
  const [gridFocus, setGridFocus] = useState(false);
  let _bChkBtn: boolean = false;
  const [btnStChange, setbtnStChangeText] = useState<string>("발행");
  const [btnCls, setbtnClsText] = useState<string>("마감");
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [addInfoFlags, setAddInfoFlags] = useState<string[]>([]);
  //#endregion

  //#endregion
  const loadAddInfoFlags = async (idTarget = "grid1") => {
    try {
      const data: any = await fnGetDataSet({
        id: "sys_addinfo_pop_01_01",
        params: {
          cd_firm: userInfo?.cd_firm ?? "",
          cd_menu: "SN_PRD_WMO_REG_001",
          id_target: idTarget,
        },
      });

      const metaRows = data?.[0] || [];
      const orderedMetaRows = [...metaRows].sort(
        (a: any, b: any) => Number(a?.no_line ?? 0) - Number(b?.no_line ?? 0)
      );
      const flags = extractAddInfoFlags(orderedMetaRows);
      const flagNames = (orderedMetaRows || []).reduce(
        (acc: Record<string, string>, row: any) => {
          const cdFlag = String(row?.cd_flag ?? "").trim();
          const nmFlag = String(row?.nm_flag ?? "").trim();
          if (cdFlag) {
            acc[cdFlag] = nmFlag || cdFlag;
          }
          return acc;
        },
        {}
      );
      const flagOrders = (orderedMetaRows || []).reduce(
        (acc: Record<string, number>, row: any) => {
          const cdFlag = String(row?.cd_flag ?? "").trim();
          const noLine = Number(row?.no_line ?? 0);
          if (cdFlag) {
            acc[cdFlag] = Number.isFinite(noLine) ? noLine : 0;
          }
          return acc;
        },
        {}
      );
      setAddInfoFlags(flags);
      return { flags, flagNames, flagOrders };
    } catch (error: any) {
      setAddInfoFlags([]);
      return {
        flags: [],
        flagNames: {} as Record<string, string>,
        flagOrders: {} as Record<string, number>,
      };
    }
  };
  useEffect(() => {
    const fetchform = async () => {
      try {
        const defaultForm = {
          cd_biz: userInfo.cd_biz,
          cd_emp: userInfo.cd_emp,
          nm_emp: userInfo.nm_emp,
        };
        const rtn: any = await getInitFormData();
        const { flags, flagNames, flagOrders } =
          await loadAddInfoFlags("grid1");

        const baseGrid1Col = rtn?.grid?.grid1?.[0] || {};
        const nextSeqBase = Array.isArray(rtn?.grid?.grid1)
          ? rtn.grid.grid1.length
          : 0;
        const addInfoColumns = flags.map((flag: string, index: number) => ({
          ...baseGrid1Col,
          cd_column: flag,
          nm_column: flagNames[flag] || flag,
          tp_column: "SnTextBox",
          fg_visible: "Y",
          yn_required: "N",
          yn_sum: "N",
          yn_allowsorting: "Y",
          yn_fixed: "N",
          qt_width: 120,
          no_seq: nextSeqBase + (flagOrders[flag] || index + 1),
          dc_editcon: "",
          cd_popup: "",
          tp_format: "",
          nm_group: "",
        }));
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData({ ...rtn.formData, ...defaultForm }); // 조회조건 초기값
        setColums({
          grid1: [...rtn.grid.grid1, ...addInfoColumns],
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useEffect(() => {
    if (
      Menuprops.figure &&
      columns.grid1.length > 0 &&
      columns.grid2.length > 0
    ) {
      onActivate(Menuprops.nodeData);
    }
  }, [columns, Menuprops]);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    const modifiedRowsL2 = gridRefs.current["grid3"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0 ||
      modifiedRowsL2.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const checkSave: any = await onSave();
        if (!checkSave) {
          return;
        }
      }
    }
    try {
      const params = {
        id: "sn_prd_wmo_reg_002_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      const flags =
        addInfoFlags.length > 0
          ? addInfoFlags
          : (await loadAddInfoFlags("grid2")).flags;
      const sourceRows = (data[0] || []).map((row: any) => ({
        ...row,
        js_addinfo: row?.js_addinfo ?? row?.js_addinfo_h,
      }));
      setDataSources({
        grid1: hydrateRowsWithAddInfo(sourceRows, flags),
        grid2: data[1] || [],
        grid3: data[2] || [],
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onSave = async () => {
    try {
      if (_bChkBtn === false) {
        return;
      }
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();
      gridRefs.current["grid3"].current?.stopEditing();

      await new Promise((resolve) => setTimeout(resolve, 0));
      const requiredValuesCheck =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheck) {
        return;
      }
      const changesRow = gridRefs.current["grid1"].current.getChange();
      const SaveData = {
        prd_wo: changesRow,
      };
      if (changesRow.modifiedRowcount === 0) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      await fnSave("SN_PRD_WMO_REG_002_SAVE_01", SaveData);
      const focusedRow = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedRow) {
        focusKeyRef.current = {
          no_wo: focusedRow.data.no_wo,
        };
      }
      // 저장이 끝났으니 변경이력을 먼저 비운다.
      // onSearch가 첫 줄에서 getChange로 "수정된 내용이 있습니다"를 묻기 때문에
      // 여기서 비우지 않으면 방금 저장한 행이 미저장으로 잡혀 확인창이 뜬다.
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      await onSearch();

      return true;
    } catch (error: any) {}
  };
  //#endregion

  const onFocusedRowChanged = (event: any) => {
    if (!event) {
      return;
    }
    const no_wo = event.no_wo;
    setSelectedDocu(no_wo);

    if (event.st_wo === "F") {
      setbtnStChangeText("발행");
    } else {
      setbtnStChangeText("발행취소");
    }

    if (event.st_wo === "C") {
      setbtnClsText("마감취소");
    } else {
      setbtnClsText("마감");
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    const selectedRows = gridRefs.current["grid1"].current.focusedRowNode();
    if (id == "btnStChange") {
      if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) {
        return;
      }
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        showDialog(
          "alter",
          "Another work is in progress.Please save and proceed."
        );
        return;
      }
      if (selectedRows.data?.st_wo === "F") {
        const conFirm = await showDialog("confirm", "발행 하시겠습니까?");
        if (conFirm) {
          selectedRows.setDataValue("st_wo", "R");
          _bChkBtn = true;
          await onSave();
          _bChkBtn = false;
        } else {
          return;
        }
        setbtnStChangeText("발행취소");
      } else if (selectedRows.data?.st_wo === "R") {
        const noWo = selectedRows.data?.no_wo;
        ///////////
        const sqlQuery1 = {
          sql: "select count(*) as cnt from prd_woproc where cd_firm = :cd_firm and no_wo = :no_wo and qt_work <> 0",
          cd_firm: userInfo.cd_firm,
          no_wo: noWo,
        };
        const params1 = await getTablebySql(sqlQuery1);
        let cnt1 = params1?.length > 0 ? params1[0]["cnt"] : 0;
        if (cnt1 > 0) {
          showDialog("alter", "실적이 존재하는 건이 포함되어 있습니다.");
          return;
        }
        //////////
        const sqlQuery2 = {
          sql: "select count(1) as cnt from mtl_isureql where cd_firm = :cd_firm and no_order = :no_order",
          cd_firm: userInfo.cd_firm,
          no_order: noWo,
        };
        const params2 = await getTablebySql(sqlQuery2);
        let cnt2 = params2?.length > 0 ? params2[0]["cnt"] : 0;
        if (cnt2 > 0) {
          showDialog("alter", "B/F 출고요청건 포함되어 있습니다.");
          return;
        }
        ///////////
        const sqlQuery3 = {
          sql: "select count(1) as cnt from mtl_qtio where cd_firm = :cd_firm and no_order = :no_order",
          cd_firm: userInfo.cd_firm,
          no_order: noWo,
        };
        const params3 = await getTablebySql(sqlQuery3);
        let cnt3 = params3?.length > 0 ? params3[0]["cnt"] : 0;
        if (cnt3 > 0) {
          showDialog("alter", "B/F 출고건이 포함되어 있습니다.");
          return;
        }
        const conFirm = await showDialog("confirm", "발행 취소하시겠습니까?");
        if (conFirm) {
          selectedRows.setDataValue("st_wo", "F");
          _bChkBtn = true;
          await onSave();
          _bChkBtn = false;
        } else {
          return;
        }
        setbtnStChangeText("발행");
      }
    }
    const saveStWo = async (node: any, stWo: string) => {
      node.setDataValue("st_wo", stWo);
      _bChkBtn = true;
      await onSave();
      _bChkBtn = false;
    };
    if (id == "btnCls") {
      if (gridRefs.current["grid1"].current.getDisplayedRowCount() < 1) {
        return;
      }
      if (selectedRows.data?.st_wo === "C") {
        const confirm = await showDialog("confirm", "마감취소 하시겠습니까?");
        if (confirm) {
          const noWo = selectedRows.data?.no_wo;
          ///////////
          const sqlQuery1 = {
            sql: "select count(*) as cnt from prd_woproc where cd_firm = :cd_firm and no_wo = :no_wo and qt_work > 0",
            cd_firm: userInfo.cd_firm,
            no_wo: noWo,
          };
          const params1 = await getTablebySql(sqlQuery1);
          const hasWork = (params1?.[0]?.cnt ?? 0) > 0;
          await saveStWo(selectedRows, hasWork ? "S" : "R");
          setbtnClsText("마감");
          return;
        }
      }

      if (selectedRows.data?.st_wo === "F") {
        showDialog("alter", "확정 상태에선 마감처리가 불가합니다.");
        return;
      }

      // 한글 주석: 발행(R)은 실적이 없으므로 기존대로 상태값만 마감(C)으로 바꿔 저장한다.
      if (selectedRows.data?.st_wo !== "S") {
        if (!(await showDialog("confirm", "마감처리 하시겠습니까?"))) return;
        await saveStWo(selectedRows, "C");
        setbtnClsText("마감취소");
        return;
      }

      // 한글 주석: 진행(S) 마감. 잔량 있음 → 예=연계 생성 후 마감, 아니오=연계 없이 마감, 취소=중단
      //            잔량 없음 → 예=마감, 아니오=중단
      const qtRemain =
        Number(selectedRows.data?.qt_wo ?? 0) -
        Number(selectedRows.data?.qt_work ?? 0);
      let makeLink = false;
      if (qtRemain > 0) {
        const answer = await showDialog(
          "confirmCancel",
          `남은 작업지시 수량이 ${qtRemain}건 있습니다.\n연계 작업지시를 생성하시겠습니까?\n(아니오: 연계 없이 마감, 취소: 중단)`
        );
        if (answer === undefined) return;
        makeLink = answer;
      } else if (!(await showDialog("confirm", "마감처리 하시겠습니까?"))) {
        return;
      }

      // 한글 주석: 진행 마감은 백엔드 한 트랜잭션으로 처리한다.
      // 지시량=실적량으로 맞추고 공정 지시량·자재 소요량을 재계산해야 하므로
      // st_wo만 바꾸는 onSave 경로를 쓰지 않는다. 연계 생성도 같은 트랜잭션 안에서 한다.
      const res = await callApi("SN_PRD_WMO_REG_002_btnCls", {
        cd_firm: userInfo.cd_firm,
        no_wo: selectedRows.data?.no_wo,
        dt_wo: todayform,
        make_link: makeLink ? "Y" : "N",
      });
      if (!res?.status) return;
      const noWoNew = res?.data?.no_wo_new ?? "";
      if (noWoNew) {
        await showDialog(
          "alter",
          `연계 작업지시 ${noWoNew} 가 생성되고 마감처리 되었습니다.`
        );
      }
      await onSearch();
      setbtnClsText("마감취소");
    }
  };
  //#region onActivate
  const onActivate = async (nodeData: any) => {
    if (!nodeData) return;
    if ((Menuprops.figure as string) === "fg_drilldown.Search") {
      const selectedData = {
        cd_firm: userInfo?.cd_firm,
        cd_biz: userInfo?.cd_biz,
        dt_from: nodeData[1],
        dt_to: nodeData[1],
        no_wo: nodeData[0],
        tp_wo: "",
        cd_rout: "",
        cd_cust_prd: "",
        cd_wc: "",
        cd_equip: "",
        st_wo: "",
        fg_wo: "",
      };
      setFormData(selectedData);
      await new Promise((resolve) => setTimeout(resolve, 100));
      await onSearch();
    }
  };
  const TabChangedEvent = (index: any) => {
    setTapPage(index);
  };

  //#endregion
  const onRowDataReady = () => {
    const focusKey = focusKeyRef.current;
    if (!focusKey) return;

    const grid = gridRefs.current["grid1"].current;

    const rowCount = grid.getDisplayedRowCount();
    let targetIndex = -1;

    for (let i = 0; i < rowCount; i++) {
      const rowNode = grid.getRowNodeAtIndex(i);
      if (!rowNode?.data) continue;

      if (rowNode.data.no_wo === focusKey.no_wo) {
        targetIndex = i;
        break;
      }
    }

    if (targetIndex >= 0) {
      grid.selectAndFocusRow(targetIndex);
      grid.scrollToIndex?.(targetIndex);
    } else {
      grid.selectAndFocusRow(0);
    }

    focusKeyRef.current = null;
  };
  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onRowDataReady: onRowDataReady,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {},
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {},
      },
    }),
    [columns, dataSources]
  );

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{ rowSelection: "single", title: "작업지시" }}
            events={grids.grid1.events}
            filter={{
              refs: [gridRefs.current["grid2"], gridRefs.current["grid3"]],
              columns: ["no_wo"],
            }}
            header={
              <div>
                <SnButton
                  text={btnStChange}
                  onClick={() => {
                    onGrid1BtnsClick("btnStChange");
                  }}
                />
                <SnButton
                  text={btnCls}
                  onClick={() => {
                    onGrid1BtnsClick("btnCls");
                  }}
                />
              </div>
            }
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnTab
            titles={["자재정보", "공정정보"]}
            width={"100%"}
            onTabChanged={TabChangedEvent}
            body={[
              <SnGrid
                ref={gridRefs.current["grid2"]} // Grid Name
                columnConfig={grids.grid2.columns} // 컬럼 설정 전달
                rowData={grids.grid2.dataSource} // Datasource
                events={grids.grid2.events}
              />,

              <SnGrid
                ref={gridRefs.current["grid3"]} // Grid Name
                columnConfig={grids.grid3.columns} // 컬럼 설정 전달
                rowData={grids.grid3.dataSource} // Datasource
                events={grids.grid3.events}
              />,
            ]}
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PRD_WMO_REG_002;
